import { http } from 'helpers/httpv2';

const URL_V2 = process.env.REACT_APP_API_V2;
const actionplanList = 'okr/find?page=1&page_size=100&filter[okr_type]=northstar_objective&filter[assignment_as]=action_plan';
const actionplanListTeam = 'okr/find?page=1&page_size=100&filter[okr_type]=northstar_objective&filter[assignment_as]=action_plan&filter[assignment_type]=team';
const actionplanListDepartment = 'okr/find?page=1&page_size=100&filter[okr_type]=northstar_objective&filter[assignment_as]=action_plan&filter[assignment_type]=department';

export const apiActionplanList = async (val) => {
  let url = `${URL_V2 + actionplanList}&filter[status]=active`;
  if (val === 'employee') {
    url = `${URL_V2 + actionplanList}&filter[myokr]=true&filter[status]=active`;
  }

  const datas = await http.get(`${url}`);
  return datas.data.data;
};
export const apiActionplanListTeam = async () => {
  const datas = await http.get(`${URL_V2 + actionplanListTeam}`);
  return datas.data.data;
};
export const apiActionplanListDepartment = async () => {
  const datas = await http.get(`${URL_V2 + actionplanListDepartment}`);
  return datas.data.data;
};
